import { AppBar, Autocomplete, Box, Button, MenuItem, Select, TextField, InputAdornment, OutlinedInput, IconButton, styled, createTheme, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as api from '../services/api'
import Loader from '../../components/Loader'
import styles from './login.module.css'
import logo from '../../assets/icons/logo.svg'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import dayjs from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import ModalCalendar from '../../components/modal/ModalCalendar'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from 'moment/moment'
import camera from '../../assets/icons/camera.svg'

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";


import ModalAlert from 'utils/components/modal-alert'
import { useSelector } from 'react-redux'
import Footer from 'components/Footer'

function ChangePassword() {
    const version = useSelector(state => state.vers.value)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [data, setData] = useState({
        pid: "", //เลขบัตรประชาชน
        password: "",
        confirm_password: "",
        access_token: '',
    });

    const [openAlert, setOpenAlert] = useState(false)
    const [alertType, setAlertType] = useState('')
    const handleOpenAlert = (type) => {
        setOpenAlert(type)
    }

    const [isValidpid, setIsValidpid] = useState(false);
    const [messageAlert, setMessageAlert] = useState('')

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);


    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseDownConfirmPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpConfirmPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        getParameter()
    }, [])

    const getParameter = async () => {
        let verify_token = new URLSearchParams(window.location.search).get('verify_token')
        let pid = new URLSearchParams(window.location.search).get('pid')
        setData({ ...data, pid: pid, access_token: verify_token })


    }

    const clickChanagePassword = async () => {

        // setLoading(true)

        if (!data['password']) {
            setAlertType('error')
            handleOpenAlert(true)
            setMessageAlert('กรุณากรอกรหัสผ่าน')

        }

        if (!data['confirm_password']) {
            setAlertType('error')
            handleOpenAlert(true)
            setMessageAlert('กรุณากรอกยืนยันรหัสผ่าน')

        }

        if (!isValid) {
            setAlertType('error')
            handleOpenAlert(true)
            setMessageAlert('กรุณาตรวจสอบรหัสผ่าน รหัสผ่านไม่ตรงตามเงื่อนไข')
        }

        if (data['password'] != data['confirm_password']) {
            setAlertType('error')
            handleOpenAlert(true)
            setMessageAlert('กรุณาตรวจสอบรหัสผ่าน')

        }

        let payload = {
            "new_password": data.password
        }
        let result = await api.ApiPutPassword(data.access_token, payload)
        if (result) {
            setAlertType('success')
            handleOpenAlert(true)
            setMessageAlert('รีเซ็ตรหัสผ่านสำเร็จ')
            setLoading(false)

            setTimeout(() => {
                handleOpenAlert(false)
                navigate('/login')
            }, 3000);
        } else {
            setLoading(false)
        }
    }


    const handleAlert = () => {

    }

    const validations = {
        length: data['password'].length >= 8,
        hasUpper: /[A-Z]/.test(data['password']),
        hasLower: /[a-z]/.test(data['password']),
        hasSpecial: /[!@#฿%^&*()_+\-=\[\]{}|:;"',.<>\/?\\]/.test(data['password']),
        noSpaces: /^\S+$/.test(data['password']),
    };

    const isValid = Object.values(validations).every(Boolean);

    return (
        <>
            <Loader loading={loading} />
            <AppBar
                position="sticky"
                sx={{
                    backgroundColor: '#FFFFFF',
                    padding: '10px',
                    color: '#000000',
                    "@media (max-width: 800px)": {
                        fontSize: '12px'
                    },
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px'
                    }}>
                        <img className={styles.logo} src={logo} />
                        <Box>
                            <div>ระบบข้อมูลสุขภาพกำลังพล สป.</div>
                            <div style={{ fontSize: '12px' }}>เวอร์ชัน {version || '-'}</div>
                        </Box>
                    </Box>
                    <Box>
                        <Button
                            variant='contaimed'
                            sx={{ backgroundColor: '#D1E6FF' }}
                            onClick={() => { navigate('/login') }}
                        >เข้าสู่ระบบ</Button>
                    </Box>
                </Box>
            </AppBar>




            <Box sx={design.container}>
                <Box sx={design.mainSection}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px'
                    }}>
                        <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                        <Box sx={{
                            cursor: 'pointer'
                        }}
                            onClick={() => { navigate('/login') }}
                        >กลับไป หน้าแรก</Box>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        fontSize: '20px',
                        "@media (max-width: 1100px)": {
                            fontSize: '16px',
                        },
                        "@media (max-width: 800px)": {
                            fontSize: '14px',
                        },
                    }}>
                        <Box sx={{
                            display: 'grid',
                            gridGap: '20px',
                            width: '700px',
                            "@media (max-width: 1100px)": {
                                width: '500px'
                            },
                            "@media (max-width: 800px)": {
                                width: '100%'
                            },
                        }}>

                            <Typography sx={{
                                textAlign: 'center',
                                fontWeight: 600,
                                fontSize: '20px',

                            }}>เปลี่ยนรหัสผ่าน</Typography>


                            <Box>
                                <Box>เลขบัตรประจำตัวประชาชน</Box>
                                <TextField
                                    InputProps={{
                                        sx: {
                                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                                display: 'none'
                                            },
                                            '& input[type=number]': {
                                                MozAppearance: 'textfield'
                                            },
                                        }
                                    }}
                                    type='number'
                                    placeholder='เลขบัตรประจำตัวประชาชน'
                                    size="small"
                                    fullWidth
                                    value={data["pid"]}
                                    name={"pid"}
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    onChange={(e) => {
                                        setData({ ...data, 'pid': !e.target.value ? null : String(e.target.value).slice(0, 13) });
                                    }}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: isValidpid ? 'red' : '',
                                            }
                                        },
                                    }}
                                />
                            </Box>


                            <Box>รหัสผ่าน</Box>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showPassword ? "text" : "password"}
                                placeholder='รหัสผ่าน'
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={data.password}
                                onChange={(e) => { setData({ ...data, password: e.target.value }) }}
                                error={!isValid && data.password.length > 0}
                                helperText={
                                    !validations.length && data.password.length > 0
                                        ? 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร'
                                        : ''
                                }
                                endAdornment={
                                    <InputAdornment position="end" >
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />

                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder='ยืนยันรหัสผ่าน'
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={data.confirm_password}
                                onChange={(e) => { setData({ ...data, confirm_password: e.target.value }) }}
                                endAdornment={
                                    <InputAdornment position="end" >
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowConfirmPassword}
                                            onMouseDown={handleMouseDownConfirmPassword}
                                            onMouseUp={handleMouseUpConfirmPassword}
                                            edge="end"
                                        >
                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />

                            <Box>
                                <Box sx={{ fontSize: '16px' }}>เงื่อนไขการตั้งรหัสผ่าน:</Box>
                                <ul style={{ listStyle: 'none', paddingLeft: 0, fontSize: '15px' }}>
                                    <li style={{ color: validations.length ? 'green' : '#E06262' }}>
                                        - รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัว
                                    </li>
                                    <li style={{ color: validations.hasUpper && validations.hasLower ? 'green' : '#E06262' }}>
                                        - รหัสผ่านต้องประกอบด้วยตัวอักษรภาษาอังกฤษ ตัวพิมพ์ใหญ่อย่างน้อย 1 ตัว และตัวพิมพ์เล็กอย่างน้อย 1 ตัว
                                    </li>
                                    <li style={{ color: validations.hasSpecial ? 'green' : '#E06262' }}>
                                        - รหัสผ่านต้องประกอบด้วยสัญลักษณ์พิเศษ เช่น @,?,!,฿,&,%,* หรืออื่น ๆ อย่างน้อย 1 ตัว
                                    </li>
                                    <li style={{ color: validations.noSpaces ? 'green' : '#E06262' }}>
                                        - รหัสผ่านห้ามมีช่องเคาะหรือเว้นว่าง
                                    </li>
                                </ul>
                            </Box>

                            <Box sx={{ textAlign: 'center' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: "150px",
                                        "@media (max-width: 800px)": {
                                            width: "100px",
                                        },
                                    }}
                                    onClick={clickChanagePassword}
                                >เปลี่ยนรหัสผ่าน</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Footer />

            <ModalAlert
                loading={loading}
                title={'แจ้งเตือน'}
                type={alertType}
                message={messageAlert}
                open={openAlert}
                setOpen={setOpenAlert}
                handleChange={handleAlert}

            />
        </>
    )
}

const design = {
    container: {
        display: "flex",
        bgcolor: "neutral.light",
    },
    mainSection: {
        px: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        py: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        width: "100%",
        height: "100%",
        overflow: "auto",
    },
};

const StyledMobileDatePicker = styled(MobileDatePicker)({
    '& .MuiTextField-root': {
        margin: '20px',
    },
    "& .MuiInputBase-input": {
        padding: '8.5px 14px'
    }
});

const DatePicker = {
    width: '100%'
}

export default ChangePassword
